import * as types from "../mutation-types";

// Disabling shadow as state object is shadowed, but this is the Vue best practice.
/* eslint no-shadow: 0 */

const state = {
  overlays: [
    {
      alias: "navigation",
      open: false,
    },
  ],
};

const getters = {};

const actions = {
  openOverlay ( context, payload ) {
    context.commit( types.OVERLAY_OPEN, payload );
  },
  closeOverlay ( context, payload ) {
    context.commit( types.OVERLAY_CLOSE, payload );
  },
};

const mutations = {
  [types.OVERLAY_OPEN] ( state, payload ) {
    const currentOverlay = state.overlays.find( x => x.alias === payload.alias );
    if ( currentOverlay ) {
      currentOverlay.open = true;
    }
  },
  [types.OVERLAY_CLOSE] ( state, payload ) {
    const currentOverlay = state.overlays.find( x => x.alias === payload.alias );
    if ( currentOverlay ) {
      currentOverlay.open = false;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
